// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"20c4dd2f","710":"7d478a0d","845":"16a3cc75"}[chunkId] + ".chunk.js";
};